const parseFormattedNumber = (text: string): number | undefined => {
  if (text === undefined) {
    return undefined
  }
  const parsedNumber = parseFloat(text.replaceAll(/[\\.]/g, '').replaceAll(/,/g, '.'))
  if (isNaN(parsedNumber)) {
    return undefined
  }
  return parsedNumber
}

export default parseFormattedNumber
